var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarouselIndicator = function SvgCarouselIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F2EF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.083,
    d: "M1.625 1.583h9.75M10.292 3.75H2.708c-.598 0-1.083.485-1.083 1.083v4.333c0 .599.485 1.084 1.083 1.084h7.584c.598 0 1.083-.485 1.083-1.084V4.833c0-.598-.485-1.083-1.083-1.083M1.625 12.417h9.75"
  })));
};
export default SvgCarouselIndicator;